import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushirefortoristinpune() {



  const cardData =
  {
    keyword: 'Bus Hire for Tourist in Pune ',
    heading: 'Sanavi Travels: Bus Hire for Tourist in Pune',
    headingDescription: 'Sanavi Travels offers reliable Bus Hire for Tourists in Pune, providing safe, comfortable, and well-organized transportation solutions for domestic and international tourists, travel groups, families, and sightseeing tours exploring Pune and nearby destinations. Our fleet includes luxury AC and Non-AC buses ranging from 20, 25, 30, 32, 35, 40, 45 to 50 seaters, along with tempo travellers on request, all well-maintained with spacious seating, ample luggage capacity, and modern amenities to ensure a pleasant travel experience. With experienced tourist-route drivers, customizable sightseeing and outstation packages, transparent pricing, and dependable service, Sanavi Travels ensures smooth, punctual, and hassle-free journeys. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular tourist destinations such as Lonavala, Mahabaleshwar, Lavasa, Shirdi, Nashik, Konkan, Goa, Mumbai, Aurangabad, and nearby attractions. Choose Sanavi Travels for trusted bus hire services for tourists in Pune, delivering comfort, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a proud symbol of Maratha power. Once the administrative seat of Peshwa Bajirao I, it features massive stone walls, grand gateways like the Delhi Darwaza, and landscaped courtyards. Although a major fire destroyed much of the structure, the remaining ruins still reflect royal grandeur. The evening light-and-sound show narrates the legacy of the Marathas. Shaniwar Wada remains the cultural and historical heart of Pune."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a landmark deeply connected with India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it functions as a museum showcasing photographs, personal belongings, and historical records. The palace is surrounded by lush gardens and elegant Italian-style architecture. It stands as a symbol of sacrifice, peace, and national pride."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual destination, dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts thousands of devotees every day. During Ganesh Chaturthi, the temple becomes the center of grand celebrations, processions, and cultural events. The temple trust is also known for its extensive charitable work. Dagdusheth Ganpati is the spiritual soul of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort famous for the heroic sacrifice of Tanaji Malusare in 1670 for Chhatrapati Shivaji Maharaj. Perched atop a rugged hill, the fort offers panoramic views of the Sahyadri mountain range. Visitors can trek or drive up to explore ancient gates, memorials, and viewpoints. Sinhagad is a perfect blend of history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in the bustling city center, the temple offers a calm and meditative atmosphere. Its monolithic pillars and ancient carvings reflect early Indian architectural excellence. Pataleshwar is one of Pune’s finest hidden heritage sites."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural heritage. The collection includes musical instruments, traditional household items, sculptures, and ornaments. The recreated Mastani Mahal is a major attraction. The museum is an essential destination for history lovers and cultural enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers stunning panoramic views of the city. After climbing 103 stone steps, visitors reach the Parvati Temple complex built during the Peshwa era. Smaller temples and a museum add historical value. Sunrise and sunset views from Parvati Hill are especially mesmerizing."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the globe. Spread across serene landscaped gardens, it offers meditation programs, wellness therapies, and mindfulness practices. The calm environment promotes relaxation and inner peace. Osho Ashram represents Pune’s global spiritual and wellness identity."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, manicured lawns, and seasonal flowers create a tranquil setting. It is popular among families, walkers, and photography enthusiasts. The garden offers a refreshing escape from city life."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure and picnic spot near Pune, especially during monsoon and evenings. The vast reservoir, cool breeze, and surrounding hills create a scenic environment. Local food stalls enhance the visitor experience. The dam also serves as the gateway to Sinhagad Fort, making it a perfect short getaway."
  }
]
,




"services": [
  {
    "name": "Bus Hire for Tourist in Pune",
    "description": "Bus Hire for Tourist in Pune offers comfortable and reliable bus services specially designed for tourists visiting Pune and nearby destinations. Ideal for sightseeing, local tours, and outstation travel, this service provides spacious buses, professional drivers, and smooth travel experiences. Tourists can enjoy hassle-free transportation with safety, comfort, and convenience throughout their journey."
  },
  {
    "name": "Tourist Bus Rental Pune",
    "description": "Tourist Bus Rental Pune provides flexible bus rental options for individual tourists, families, and groups. Well-maintained buses with comfortable seating and ample luggage space make it suitable for city tours, weekend trips, and long-distance travel. Experienced chauffeurs ensure punctuality and stress-free journeys."
  },
  {
    "name": "AC Tourist Bus Pune",
    "description": "AC Tourist Bus Pune offers air-conditioned buses for a cool and comfortable travel experience. Ideal for long tours and summer travel, these buses provide spacious interiors and smooth rides, ensuring tourists travel in comfort while exploring Pune and nearby attractions."
  },
  {
    "name": "Luxury Tourist Bus Pune",
    "description": "Luxury Tourist Bus Pune provides premium buses with elegant interiors and enhanced comfort. Perfect for luxury tours, VIP tourists, and corporate guests, this service combines style, safety, and professional chauffeur service for a superior travel experience."
  },
  {
    "name": "Family Tourist Bus Pune",
    "description": "Family Tourist Bus Pune is designed for families traveling together for sightseeing and holidays. With comfortable seating, safe driving practices, and ample space, this service ensures an enjoyable journey for children, adults, and senior citizens."
  },
  {
    "name": "Group Travel Tourist Bus Pune",
    "description": "Group Travel Tourist Bus Pune caters to large groups such as friends, tour groups, and organizations. Spacious buses and coordinated travel arrangements ensure everyone travels together comfortably, making group tours smooth and well-organized."
  },
  {
    "name": "Affordable Tourist Bus Pune",
    "description": "Affordable Tourist Bus Pune offers budget-friendly bus rental options without compromising on safety or comfort. Ideal for cost-conscious travelers, this service provides reliable buses, transparent pricing, and professional drivers."
  },
  {
    "name": "Chauffeur Driven Tourist Bus",
    "description": "Chauffeur Driven Tourist Bus provides experienced and professional drivers who manage routes, traffic, and safety. Tourists can relax and enjoy sightseeing while ensuring punctual and hassle-free travel throughout their trip."
  },
  {
    "name": "Best Tourist Bus Service Pune",
    "description": "Best Tourist Bus Service Pune is known for dependable buses, comfortable travel, and quality service. Suitable for families, tourists, and group travelers, this service focuses on punctuality, safety, and overall passenger satisfaction."
  },
  {
    "name": "Pune Tourist Bus Booking",
    "description": "Pune Tourist Bus Booking offers easy and flexible booking options for tourist bus rentals. With transparent pricing, reliable vehicles, and professional support, this service ensures convenience for all tourist travel requirements."
  },
  {
    "name": "Sightseeing Bus Pune",
    "description": "Sightseeing Bus Pune provides dedicated buses for local sightseeing tours. Ideal for exploring Pune’s landmarks, attractions, and nearby spots, this service ensures organized travel with comfort and experienced drivers."
  },
  {
    "name": "Outstation Tourist Bus Pune",
    "description": "Outstation Tourist Bus Pune offers comfortable buses for tourists traveling from Pune to nearby cities and tourist destinations. Spacious seating and skilled chauffeurs ensure smooth and enjoyable long-distance travel."
  },
  {
    "name": "Travel Bus for Tourists Pune",
    "description": "Travel Bus for Tourists Pune provides reliable transportation solutions for tourists visiting Pune. Suitable for city tours, holiday travel, and extended trips, this service focuses on comfort, safety, and professional travel management."
  },
  {
    "name": "Holiday Bus Rental Pune",
    "description": "Holiday Bus Rental Pune offers well-planned bus travel solutions for leisure and holiday trips. Designed for stress-free travel, this service ensures comfortable buses, smooth journeys, and enjoyable holiday experiences."
  },
  {
    "name": "Tourist Transport Bus Pune",
    "description": "Tourist Transport Bus Pune provides dependable transport services for tourists requiring organized and comfortable travel. With well-maintained buses and experienced drivers, this service ensures safe and pleasant journeys across Pune and beyond."
  }
],
"tableData": [
  ["Bus Hire for Tourist in Pune", "Tourist Bus Rental Pune"],
  ["AC Tourist Bus Pune", "Luxury Tourist Bus Pune"],
  ["Family Tourist Bus Pune", "Group Travel Tourist Bus Pune"],
  ["Affordable Tourist Bus Pune", "Chauffeur Driven Tourist Bus"],
  ["Best Tourist Bus Service Pune", "Pune Tourist Bus Booking"],
  ["Sightseeing Bus Pune", "Outstation Tourist Bus Pune"],
  ["Travel Bus for Tourists Pune", "Holiday Bus Rental Pune"],
  ["Tourist Transport Bus Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Luxury 12, 14, 17 Seater Tempo Traveller in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers premium luxury Tempo Travellers in Pune with 12, 14, and 17 seater options, perfect for family trips, corporate travel, group tours, and airport transfers."
  },
  {
    "WhyChooseheading": "Spacious and Luxurious Vehicles",
    "WhyChoosedescription": "Travel in highly comfortable, air-conditioned, and well-maintained luxury Tempo Travellers designed for a smooth and enjoyable journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers are experienced with Pune and nearby routes, ensuring safe, punctual, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for luxury Tempo Traveller rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel planning, and itinerary changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from local, outstation, one-way, round-trip, or customized rental plans tailored for your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All luxury Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for luxury 12, 14, and 17 seater Tempo Traveller rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer luxury 12, 14, and 17 seater Tempo Travellers in Pune?',
    answer: 'Yes, Sanavi Travels provides premium and well-maintained luxury Tempo Travellers in Pune with 12, 14, and 17 seat options.'
  },
  {
    question: 'How can I book a luxury Tempo Traveller in Pune with Sanavi Travels?',
    answer: 'You can easily book through our website or by contacting our 24×7 customer support team.'
  },
  {
    question: 'What seating options are available for luxury Tempo Traveller rentals?',
    answer: 'We offer luxury Tempo Travellers in 12-seater, 14-seater, and 17-seater configurations to suit your group size and travel needs.'
  },
  {
    question: 'Are drivers included with the luxury Tempo Traveller rental?',
    answer: 'Yes, all rentals include experienced and professional drivers.'
  },
  {
    question: 'Can I book a luxury Tempo Traveller for outstation trips?',
    answer: 'Absolutely. Sanavi Travels offers luxury Tempo Traveller rentals for both local and outstation travel.'
  },
  {
    question: 'Are the vehicles sanitized before each trip?',
    answer: 'Yes, all luxury Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Is the luxury Tempo Traveller service available 24×7?',
    answer: 'Yes, our service is available round the clock to match your travel schedule.'
  },
  {
    question: 'What payment options are available for booking?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the trip?',
    answer: 'Yes, our 24×7 customer support team is available throughout your journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Mehta',
    feedback: 'Rented a luxury 17-seater Tempo Traveller from Sanavi Travels in Pune. Very comfortable seats, clean vehicle, and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Great experience with Sanavi Travels. The 14-seater luxury Tempo Traveller was superbly maintained and the driver was very professional.',
    rating: 5
  }
];


































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Tourist in Pune - Sanavi Travels",
  "description": "Tourist bus hire in Pune by Sanavi Travels for sightseeing, family trips, group travel, outstation tours, and holiday excursions. Choose AC and luxury buses for safe, comfortable, and affordable travel for tourists.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Bus Hire for Tourist in Pune Starting from ₹40 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book tourist buses in Pune with Sanavi Travels. AC and luxury buses for sightseeing, family trips, group travel, outstation tours, and holiday excursions at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/166.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushirefortoristinpune;